export const SERVICE_ACCOUNTS_DOCS_LINK = 'https://per.co.na/pmm/3.0.0/migrate-api-keys';

export const CONTACT_SUPPORT_LINK = 'https://www.percona.com/about/contact';
